// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.input.search-group {
  width: 100%;
  padding: 8px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.modal-select-list {
  max-height: 70%;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  background-color: rgb(240, 239, 239);
}

.select-item {
  /* padding: 10px;
  border-bottom: 1px solid #cbcbcb;
  cursor: pointer;
   */
  display: inline-block;
  background-color: #79b4f4;
  color: white;
  padding: 5px 10px;
  border-radius: 15px;
  margin-right: 10px;
  margin-bottom: 5px;
  max-width: 80%;
}

.select-item:hover {
  background-color: #236cbb;
}

.select-item:last-child {
  border-bottom: none;
}

.close-modal-button{
  width: 50%;
  background-color: rgb(245, 91, 91);
  height: 25px;
  border-style: none;
  border-radius: 7px;
  color: white;
  font-size: 20px;
}

.close-modal-button:hover{
  background-color: rgb(205, 49, 49);
}
`, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/Maintenance/Maintenance-styles/modalSelector.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE;;;IAGE;EACF,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["\n.input.search-group {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.modal-select-list {\n  max-height: 70%;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 20px;\n  background-color: rgb(240, 239, 239);\n}\n\n.select-item {\n  /* padding: 10px;\n  border-bottom: 1px solid #cbcbcb;\n  cursor: pointer;\n   */\n  display: inline-block;\n  background-color: #79b4f4;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 15px;\n  margin-right: 10px;\n  margin-bottom: 5px;\n  max-width: 80%;\n}\n\n.select-item:hover {\n  background-color: #236cbb;\n}\n\n.select-item:last-child {\n  border-bottom: none;\n}\n\n.close-modal-button{\n  width: 50%;\n  background-color: rgb(245, 91, 91);\n  height: 25px;\n  border-style: none;\n  border-radius: 7px;\n  color: white;\n  font-size: 20px;\n}\n\n.close-modal-button:hover{\n  background-color: rgb(205, 49, 49);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
